/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section1_TitleInputs */

const en_about_section1_title = /** @type {(inputs: About_Section1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is PureJSON?`)
};

const ko_about_section1_title = /** @type {(inputs: About_Section1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON이란?`)
};

const ja_about_section1_title = /** @type {(inputs: About_Section1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONとは？`)
};

/**
* | output |
* | --- |
* | "What is PureJSON?" |
*
* @param {About_Section1_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section1_title = /** @type {((inputs?: About_Section1_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section1_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section1_title(inputs)
	if (locale === "ko") return ko_about_section1_title(inputs)
	return ja_about_section1_title(inputs)
});